export default "__VITE_ASSET__BR1B8ofV__"